/**
 * Tras 401/403 vuelve a consultar `/api/auth/session`; si el token venció,
 * `AuthProvider` pone `user` en null y las rutas protegidas redirigen al login.
 */
export async function fetchWithSessionSync(
  input: RequestInfo | URL,
  init: RequestInit | undefined,
  refresh: () => Promise<void>,
): Promise<Response> {
  const r = await fetch(input, { credentials: "include", ...init });
  if (r.status === 401 || r.status === 403) {
    await refresh();
  }
  return r;
}
